export type AxePurchaseState =
  | 'none'
  | 'trialing'
  | 'trial_ended'
  | 'trial_payment_failed'
  | 'paid'
  | 'paid_payment_failed'
  | 'free'
  | 'free_payment_failed';

export enum ProductSlugs {
  advancedRules = 'advanced-rules',
  axeDevToolsHTML = 'axe-devtools-html',
  axeDevToolsMobile = 'axe-devtools-mobile',
  axeDevToolsExtension = 'axe-devtools-pro',
  axeDevToolsWatcher = 'axe-devtools-watcher',
  axeLinter = 'axe-devtools-linter',
  axeReports = 'axe-reports',
  axeMonitor = 'axe-monitor',
  axeAuditor = 'axe-auditor',
  dequeUniversity = 'deque-university',
  axeSpider = 'axe-spider',
  jiraIntegration = 'jira-integration',
  jiraOnPremIntegration = 'jira-on-prem-integration',
  jiraDirectCloudIntegration = 'jira-direct-cloud-integration',
  axeAuditorIntegration = 'axe-auditor-integration',
  customIntegration = 'custom-integration',
  axeAssistantSlack = 'axe-assistant-slack',
  axeAssistantTeams = 'axe-assistant-teams',
  scimService = 'scim-service',
  axeMCPServer = 'axe-mcp-server'
}
export interface EnterpriseAccount {
  id: string;
  name: string;
  stripe_id: string;
  axe_purchase_state: AxePurchaseState;
  axe_trial_end_time: number;
  root_group: string | null;
  auto_add_users: boolean;
}

export interface EnterpriseSubscription {
  id: string;
  product_id: string;
  product_slug: string;
  enterprise_id: string;
  purchase_state: string;
  stripe_id: string | null;
  license_count: number | null;
  unit_count: number | null;
  start_date: Date | null;
  end_date: Date | null;
  trial_expires: Date | null;
  current_period_start: Date | null;
  current_period_end: Date | null;
  auto_add_users: boolean;
  cancel_at: Date | null;
  sub_group: string | null;
  instance_url: string | null;
  offline_license_key: string | null;
}

export interface Enterprise
  extends Omit<
    EnterpriseAccount,
    'axe_trial_expires' | 'axe_purchase_state' | 'axe_trial_end_time'
  > {
  subscriptions: EnterpriseSubscription[];
  default_payment_method_id: string | null;
}

export interface IntegrationConnection {
  id: string;
  product_slug: string;
  credential_id: string | null;
  base_url: string | null;
  enterprise_id: string;
  connected_user_id: string;
  status: string;
  created_at: Date;
  updated_at: Date;
  access_token: string | null;
  refresh_token: string | null;
  token_metadata: Record<string, unknown> | null;
  public_key: string | null;
  private_key: string | null;
  consumer_key: string | null;
  secret: string | null;
  name: string | null;
}

export interface IntegrationTemplate {
  id: string;
  enterprise_id: string;
  product_slug: string | null;
  project_id: string;
  issue_type_id: string;
  name: string;
  field_mappings: Record<string, unknown> | null;
  impact_mappings: Record<string, unknown> | null;
  custom_labels: string[];
  created_by: string | null;
  created_at: Date;
  updated_by: string | null;
  updated_at: Date | null;
  integration_connection_id: string;
}

export interface IssueMetadata {
  id: string;
  issue_id: string;
  fingerprint: string | null;
  group_id: string;
  product_source_slug: string;
  integration_connection_id: string;
  integration_project_id: string;
  integration_issue_id: string;
  integration_url: string;
  created_by_user_id: string;
  enterprise_id: string;
  created_at: Date;
  updated_at: Date;
  product_source_url: string;
}

export type ProjectsAndIssueTypes = {
  id: string;
  name: string;
  issueTypes: IssueType[];
  canCreateIssue: boolean;
};

type IssueType = {
  id: string;
  name: string;
  subtask: boolean;
};
